<template>
    <div >
        <span v-if="tournoi">
            <div v-show="!setScoreWin">
        <div class="explainException" v-if="!tournoi.options.GG">
            <s-l id="exception_nb">Le nombre de joueurs ne permet pas d'affecter tous les joueurs aux différentes parties </s-l>
                    <b v-if="tournoi.options.nbJoueursParEquipe==2">pour respecter les doublettes</b>
                    <b v-if="tournoi.options.nbJoueursParEquipe==3">pour respecter les triplettes</b>.
                    <br/>
            <div v-show="tournoi.options.mode=='FORME'">
                Il y a {{nombreJoueursProbleme}} équipe qui ne pourra pas jouer à chaque partie...
            </div>
            <div v-show="tournoi.options.mode=='ALEA'">
                <span v-show="nombreJoueursProbleme==1">
                    Il y a {{nombreJoueursProbleme}} joueur qui ne pourra pas jouer toutes les parties ...
                </span>
                <span v-show="nombreJoueursProbleme>1">
                    Il y a {{nombreJoueursProbleme}} joueurs qui ne pourront pas jouer toutes les parties ...
                </span>
                
            </div>
        </div>
        <div class="explainException" v-if="tournoi.options.GG">
            <s-l id="explainExceptionGG">En mode gagnant gagnant, il est possible qu'au cours des parties le tirage ne puisse pas établir les équipes. Certains joueurs peuvent ne pas se retrouver dans des équipes.</s-l>
        </div>
        <div class="explainException">
         <s-l id="exception_role">Veuillez choisir une des règles suivants :</s-l>
        </div>
        <div class="gdBoxItem"  v-on:click="setException(0)" >
           
            <div class="labelmode">
                <div class="titlemode"> <s-l id="exception_gagne"> Ceux qui ne jouent pas, gagnent</s-l></div>
                <div class="description">
                    <i>(règles officielles)</i><br/>
                
                </div>
           
            </div>
              <s-arrow id="EXCEPTION0"/>                      
        </div>
        <div class="gdBoxItem"  v-on:click="setException(3)" v-if="tournoi.options.GG && tournoi.options.mode=='FORME'">
           
            <div class="labelmode">
                <div class="titlemode"> <s-l id="exception_gagne"> Le meilleur des perdants rencontrent le moins bon des gagnants</s-l></div>
                <div class="description">
                    <i>(les joueurs se rencontrent en fonction de leur goal average)</i><br/>
                
                </div>
           
            </div>
              <s-arrow id="EXCEPTION0"/>                      
        </div>
        <div  
            class="gdBoxItem"  v-on:click="setException(1)" 
                v-if="tournoi.options.mode=='ALEA' && tournoi.options.nbJoueursParEquipe>1">
            
            <div class="labelmode">
                <div class="titlemode"><s-l id="exception_all">Tous les joueurs jouent à chaque partie</s-l></div>
                <div class="description"> 
                    
                    <span v-if="tournoi.options.nbJoueursParEquipe==2"><s-l id="exception_detailallTriplette">Certains joueurs joueront des triplettes</s-l></span>
                    <span v-if="tournoi.options.nbJoueursParEquipe==3"><s-l id="exception_detailallDoublette">Certains joueurs joueront des doublettes</s-l></span>
                </div>
            </div>   
              <s-arrow id="EXCEPTION1"/>                       
        </div>
        <div v-if="!tournoi.options.GG && tournoi.options.nbJoueursParEquipe>1" :class="nombreJoueursProbleme==1 && !this.pairParties ? 'gdBoxItemError' : 'gdBoxItem'"  v-on:click="setException(2)">
            
            <div class="labelmode" v-show="nombreJoueursProbleme!=1 || this.pairParties ? true : false">
                <div class="titlemode"><s-l id="exception_last">Une dernière partie </s-l></div>
                <div class="description"> 
                <s-l id="exception_detaillast">Ceux qui ne jouent pas joueront ensemble dans une dernière partie.</s-l>
                </div>
            </div> 
            <div class="labelmode" v-show="nombreJoueursProbleme==1 && !this.pairParties ? true : false ">
                <div class="titlemode"><s-l id="exception_last">Une dernière partie </s-l></div>
                <div class="description"> 
                <s-l id="exception_detaillast3" >Vu qu'il n'y a qu'un joueur qui pose problème, le nombre de partie doit être pair</s-l>
                </div>
            </div>               
            <s-arrow id="EXCEPTION2"/>              
        </div>
            </div>
        <div v-show="setScoreWin" style="color:black">
            <H1 >Vous avez choisi la régle : Si un joueur n'a pas d'équipes, ils gagnent la partie</H1>
            <div style="width: 100%;text-align:center;margin-top: 20px;">

                    <b>Il gagne sur le score de :</b><br/><br/>
                
                <input class="input is-normal is-success" v-model="tournoi.options.ifNotFound.win" 
                    style="width:70px;" 
                    type="number"
                /> 
                <div style="display:inline-block;width:100px;text-align:center">A</div> 
                <input class="input is-normal is-danger" v-model="tournoi.options.ifNotFound.lose"
                 style="width:70px;" 
                    type="number"
                />
               
            </div>
            <div style="margin-top: 20px;">
                <div style="float:right">
                    <s-button theme="is-success" icon="play" label="Démarrer" @onclick="goRegleOfficiel()"/>
                   
                </div>
                <div style="float:left">
                    <s-button theme="is-warning" icon="undo" label="Revenir" @onclick="setScoreWin=false"/>
                </div>
            </div>
            </div>
        </span>
        <s-modal
            :open="modalChoiceWaitingPartie"
            @close="modalChoiceWaitingPartie=false"
            :close="true"
            title="Attendre ou pas à chaque fin de partie">
            <h1><s-l id="choiceWaitingPartie_title">Vous pouvez choisir d'attendre ou pas la fin de la partie pour générer le tirage de la partie suivante</s-l>
            </h1>
            <s-info :open="infoNotWaiting" @close="infoNotWaiting=false" :close="true" id="choiceNotWaiting">En choisissant ce mode, dès qu'un score est saisi, le tirage s'effectuera au fût et à mesure. Ainsi dès que les équipes sont complètes, ils pourront démarrer leurs parties</s-info>
            <s-info :open="infoWaiting" @close="infoWaiting=false" :close="true" id="choiceWaiting">En choisissant ce mode, il faut que tous les scores soient saisis pour pouvoir effectuer le tirage de la suivante</s-info>
            <div class="choiceWaiting">
                <span class="titleChoice">TIRAGE DE LA PARTIE SUIVANTE A LA FIN DE LA PARTIE</span>
               
                <div class="choiceIdeal">
                    <s-l id="choiceIdealWaiting">Ce mode est recommandé pour un nombre de joueurs en dessous de 35 ou si vous n'avez pas de connection INTERNET</s-l>
                </div>
                <div class="choiceInfoButton">
                    <s-button icon="info" theme="is-info" label=""  @onclick="infoWaiting=true" />
                </div>
                <div class="choiceButton">
                    <s-button theme="is-success" id="modeWaitingTrue" label="choisir ce mode" icon="" @onclick="setChoiceWaitingPartie(true)" />
                   
                </div>
            </div>
            <div class="choiceNotWaiting" v-if="possibleTirage()">
                <span class="titleChoice">TIRAGE DE LA PARTIE SUIVANTE DES QU UN SCORE EST RENSEIGNE</span>
                <div v-if="isOnline && tournoi.joueurs.length>20">
                    <div class="choiceNotWaiting_warning">
                        <s-l id="choiceNotWaiting_warning">Vous devez être connecté sur internet tout le long du concours</s-l>
                    </div>
                    <div class="choiceIdeal" v-if="tournoi.joueurs.length>=20">
                        <s-l id="choiceIdealNotWaiting">Minimum : 35 joueurs pour ce mode</s-l>
                    </div>
                
                    <div class="choiceInfoButton">
                        <s-button icon="info" theme="is-info" label=""  @onclick="infoNotWaiting=true" />
                    </div>
                    <div class="choiceButton">
                        <s-button theme="is-success" id="modeWaitingFalse" label="choisir ce mode" icon="" @onclick="setChoiceWaitingPartie(false)" />
                    </div>
                </div>
                <div v-if="isOnline && tournoi.joueurs.length<35">
                    Ce mode n'est pas accessible si le nombre de joueurs est inférieur à 35 joueurs
                </div>
                <div v-if="!isOnline">
                    Ce mode n'est accessible que si vous êtes connectés ... Merci de vous connecter sur internet...

                </div>
            </div>
        </s-modal>
    </div>
</template>
<style scoped>
.choiceNotWaiting_warning {
    color: rgb(151, 13, 13);
    font-weight: bolder;
}
.titleChoice {
    font-size: 18px;
    font-weight: bolder;
}
.choiceWaiting {
     position: relative;
    background-color: rgb(120, 184, 120);
    margin-bottom: 10px;
    height: 180px;
    padding: 10px;
}
.choiceNotWaiting {
    padding: 10px;
     position: relative;
    background-color: rgb(137, 164, 199);
    margin-bottom: 10px;
    height: 180px;
}
.choiceInfoButton {
    position: absolute;
    bottom: 10px;
    left: 10px;
}
.choiceButton {
    position: absolute;
    bottom: 10px;
    right: 10px;
}
 .explainException {
     font-size: 16px;
     color: black;
     margin-bottom: 20px;
 }
 .playerOK {
        background-image: url("../../assets/playerOK.png");
        background-repeat: no-repeat;
        background-size: contain;
        height: 100%;
        width: 100%;        
        display: inline-block;
    }
     .onePlayer {
        background-image: url("../../assets/onePlayer.png");
        background-repeat: no-repeat;
        background-size: contain;
        height: 100%;
        width: 100%;        
        display: inline-block;
        
        
    }
    .gdBoxItem {
        height: 80px;
        width: 100%;
        border: thin solid silver;
        margin-top: 20px;
        padding: 0px;
        position: relative;
       
    }
    .gdBoxItemError {
        height: 100px;
        width: 100%;
        border: thin solid silver;
        margin-top: 20px;
        padding: 0px;
         background-color: silver;
    }
    .gdBoxItem:hover{
        background-color: rgb(236, 236, 209);
        
        cursor: pointer;
    }
     .titlemode {
        font-size: 16px;
        font-weight: bold;
        width: 100%;
        text-align: center;
       color: black;
    }
    .labelmode {
       
       width:100%;
       padding-top: 10px;
    }
    .labelmodeError {
       width:100%;
       padding-top: 10px;
       background-color: gray;
    }
    .imgmode {
        float: left;
        width: 40%;
        height:100%;
        padding-left: 10px;
        padding-bottom: 10px;
    }
    .imgtype {
        float: left;
        width: 13%;
        height:100%;
        padding-left: 10px;
        padding-bottom: 10px;
    }
    .imgtype div {
        display: inline-block;
    }
    .description {
        font-size: 14px;
        width: 100%;
        text-align: center;
        height: 50%;
        padding-left: 10px;
        padding-right: 10px;
        color: black;
    }
</style>
<script>
export default {
    props: ["tournoi", "nbJoueurs"],
    data() {
        return {
            showPlayerIndividuel: true,
            showPlayer: false,
            setScoreWin: false,
            modalChoiceWaitingPartie: false,
            infoWaiting: false,
            infoNotWaiting: false
        }
    },
    computed: {
        nombreJoueursProbleme: {
            get() {
               
                if (this.tournoi.options.mode=="FORME") {
                    return 1;
                }
                else {
                    return this.nbJoueurs % (this.tournoi.options.nbJoueursParEquipe*2);
                }
                
            }
        },
        pairParties: {
            get() {
               
                return (this.tournoi.options.nbParties & 1) ? false : true;
            }
        }
    },
    methods: {
        possibleTirage() {
            if (this.tournoi.options.mode=="ALEA") {
                return false
            }
            else
                return true
        },
        setChoiceWaitingPartie(bool) {
            this.tournoi.options.choiceWaitingPartie = bool;
            this.$emit("save");
        },
        setException(exception) {
          
            this.$tuto("EXCEPTION"+exception, false, this.$route.name, "", (okGo)=>{
                if (okGo) {
                    // par default on intialise le fait qu'on doit attendre la fin de la partie pour pouvoir faire le deuxième tirage
                    this.tournoi.options.choiceWaitingPartie=true;
                    this.nav = "config";
                    var goSave = false;
                    if (exception == 0)  { // les règles officielles 
                        this.setScoreWin = true;
                        this.tournoi.options.allEquipePlay = false;
                        this.tournoi.options.addPartie = false; 
                        // on va demander si on veut attendre la fin de la partie pour pouvoir faire 
                        // la partie suivante enfin dans cas d'un mode gagnant gagnant
                        // en mode formé ou non
                        if (this.tournoi.options.GG && this.tournoi.options.nbJoueursParEquipe==2)
                            this.modalChoiceWaitingPartie = true;
                        else
                            goSave = true;
                    }
                    // ICI on est forcément en mode ALEATOIRE (pas en formé)
                    // ici 
                    else if (exception == 1)  {  
                        this.setScoreWin = false;
                        this.tournoi.options.allEquipePlay = true;
                        this.tournoi.options.addPartie = false;    
                        // SI on est doublette en mode Gagnant gagnant
                        if (this.tournoi.options.nbJoueursParEquipe==2 
                            && this.tournoi.options.GG 
                            && this.tournoi.options.mode=="ALEA") {
                            
                            this.modalChoiceWaitingPartie = true;
                        }
                        else {
                                goSave = true;
                        }
                            
                    }
                    // ICI on fait une dernière partie
                    // on doit forcément attentre la fin de la partie
                    else if (exception == 2)  { 
                        
                        if (this.nombreJoueursProbleme!=1 || this.pairParties) {
                            this.tournoi.options.allEquipePlay = false;
                            this.tournoi.options.addPartie = true; 
                            this.setScoreWin = false;
                            goSave = true;
                        }  
                    }
                    // ICI on a choisit le mode : le meilleur gagne par rapport au perdant
                    else if (exception == 3) {
                            this.tournoi.options.allEquipePlay = true;
                            this.tournoi.options.addPartie = false;   
                            this.setScoreWin = false;
                            goSave = true;
                    }
                    
                    if (goSave) {
                        
                        this.$emit("save");
                    }
                }
            })
        },
        goRegleOfficiel() {
            this.tournoi.options.allEquipePlay = false;
            this.tournoi.options.addPartie = false;    
            this.$tuto("EXCEPTION0", false, this.$route.name, "", (okGo)=>{
                this.$emit("save");   
            })
        },
        showHidePlayer() {
            var i;
            this.timeOut = setTimeout(
                p=>{
                this.showPlayer = !this.showPlayer;
                this.showHidePlayer();
                }
                , 1000
            )
        }
    },
    mounted() {
        this.showHidePlayer();
    }
}
</script>